module.exports = __webpack_public_path__ + "media/images/flags/cv-81ba1767aca033283336beb93ee7c845.svg";